import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Input } from "reactstrap";
import MaskedInput from "react-text-mask";
import firebase from "firebase";

import ModalAttention from "../components/hoc/ModalAttention";

import instance from "../services/axios";
import api from "../services/Api";

import { checkCPF, checkEMAIL } from "../libs/Validate";
import Loading from "../components/Loading";

const sexos = {
  "": "Selecione",
  masculino: "Masculino",
  feminino: "Feminino",
  naoInformado: "Prefiro não informar"
};

class Formulario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      usuarios: {},
      cancel: false,
      modal: false,
      nomeOk: "",
      maeOk: "",
      cpfOk: "",
      nascOk: "",
      sexoOk: "",
      contatoOk: "",
      emailOk: "",
      senha1Ok: "",
      senha2Ok: "",
      modalCpf: false,
      modalEmail: false,
      progressOk: true,
      progressValue: 0,
      modalEmailEnv: false,
      title: "ATENÇÃO",
      modalErrors: false,
      homeRedirect: false,
      telefoneValue: "",
      datanascValue: "",
      cpfValue: "",
      aguarde: false,
      cpfRegex: [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ".",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ".",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        "-",
        /[0-9]/,
        /[0-9]/,
      ],
      nascRegex: [/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/],
      // contatoRegex: [/\(\d{2}\)\d{4,5}-\d{4}/]

      contatoRegex: [
        "(",
        /\d/,
        /\d/,
        ")",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    };
    // this.handleCadastro = this.handleCadastro.bind(this)
    this.handleHome = this.handleHome.bind(this);
  } //end Construct

  handleHome() {
    this.setState({
      cancel: true,
    });
  }

  _onTeste = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleIsValid = (evento) => {
    const validNome = /^[A-ZÀ-Úa-zà-ú]{3,}\s[A-ZÀ-Úa-zà-ú]{2,}\s?([A-ZÀ-Úa-zà-ú]{2,})?\s?([A-ZÀ-Úa-zà-ú]{2,})?\s?([A-ZÀ-Úa-zà-ú]{2,})\s?([A-ZÀ-Úa-zà-ú]{2,})?$/;
    const validPass = /^\w{6,50}$/;

    const campo = evento.target.id;
    const value = evento.target.value;

    switch (campo) {
      case "inputNome":
        this.setState({ nomeOk: validNome.test(value) });
        break;
      case "inputMae":
        this.setState({ maeOk: validNome.test(value) });
        break;
      case "cpf":
        this.setState({ cpfOk: checkCPF(value) });
        break;
      case "inputNasc":
        this.setState({ nascOk: value.match(/^\d{2,}\/\d{2,}\/\d{4,}$/) !== null });
        break;
      case "sexo":
        this.setState({ sexoOk: value === "feminino" || value === "masculino" || value === "naoInformado"});
        break;
      case "inputContato1":
        this.setState({ contatoOk: value.match(/^\(\d{2}\)\d{4,5}-\d{3,4}/) !== null });
        break;
      case "inputEmail":
        this.setState({ emailOk: checkEMAIL(value) });
        break;
      case "inputPassword":
        this.setState({ senha1Ok: validPass.test(value) });
        break;
      case "inputPassword2":
        const comparar = this.passwd.value;
        this.setState({ senha2Ok: value === comparar && validPass.test(comparar) });
        break;
      default:
        break;
    } //Switch
  };

  verificar = () => {
    return (
      this.state.nomeOk === true &&
      this.state.cpfOk === true &&
      this.state.sexoOk === true &&
      this.state.contatoOk === true &&
      this.state.emailOk === true &&
      this.state.senha1Ok === true &&
      this.state.senha2Ok === true
    );
  };

  handleCadastro = async (e) => {
    e.preventDefault();
    this.onModal();

    if (this.verificar() && checkCPF(this.state.cpfValue)) {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(this.email.value, this.passwd.value)
        .then(async (resp) => {
          await firebase
            .auth()
            .signInWithEmailAndPassword(this.email.value, this.passwd.value)
            .then(async (user) => {
              const uid = user.uid;
              const nome = this.nome.value;
              const nome_mae = this.nome_mae.value;
              const cpf = this.state.cpfValue;
              const datanasc = this.state.datanascValue;
              const sexo = this.sexo.value;
              const telefone = this.state.telefoneValue;
              const email = this.email.value;
              const foto = null;

              const NewUser = {
                nome: nome,
                cpf: cpf,
                datanasc: datanasc,
                genero: sexo,
                telefone: telefone,
                email: email,
                foto: foto,
                uid: uid,
                nome_mae,
              };
              const token = user._lat;
              instance.defaults.headers.Authorization = token;
              this.setState({ aguarde: true });
              await api
                .saveUser(NewUser)
                .then(() => {
                  // sessionStorage.removeItem("Authorization");
                  // sessionStorage.clear();
                  user
                    .sendEmailVerification({
                      url: "http://alertacelular.al.gov.br/",
                    })
                    .then(async () => {
                      this.setState({
                        progressOk: false,
                        homeRedirect: true,
                        modalEmailEnv: true,
                        aguarde: false,
                      });
                     await firebase
                        .auth()
                        .signOut()
                        .then(() => {})
                        .catch((err) => {});
                    })
                    .catch((err) => {});
                })
                .catch((err) => {
                  console.log("err", err)
                  if (err.response.status === 422) {
                    this.setState({
                      progressOk: false,
                      homeRedirect: false,
                      modalCpf: !this.state.modalCpf,
                    });
                  }
                  var user = firebase.auth().currentUser;
                  user
                    .delete()
                    .then(() => {})
                    .catch((error) => {});
                });
            });
        })
        .catch((err) => {
          this.setState({ progressOk: false, modalEmail: true });
        });
    } else if (this.verificar() && checkCPF(this.state.cpfValue)) {
      this.setState({ progressOk: false, homeRedirect: false, modalErrors: true });
    } else {
      this.setState({ progressOk: false, homeRedirect: false, modalErrors: true });
    }
  }; //End handleCadastro

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  onModal = async (event) => {
    await this.setState({
      modalEmailEnv: false,
      modalErrors: false,
      modalCpf: false,
      modalEmail: false,
      modal: !this.state.modal,
    });
  };

  onModalCpf = (event) => {
    this.setState({ modalCpf: !this.state.modalCpf });
  };

  onModalEmail = (event) => {
    this.setState({ modalEmail: !this.state.modalEmail });
  };

  render() {
    if (this.state.cancel) return <Redirect to="/" />;

    return (
      <div className="container text-dark">
        <form>
          <div className="row">
            <div className="col-12">
              <h2>Formulário de Cadastro</h2>
            </div>
            <div className="col-12 col-sm-6 col-md-6">
              <div className="form-group">
                <label htmlFor="inputAddress">Nome Completo*</label>
                <Input
                  invalid={!this.state.nomeOk}
                  id="inputNome"
                  placeholder="Seu nome completo"
                  innerRef={(ref) => (this.nome = ref)}
                  onChange={this.handleIsValid}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputMae">Nome da Mãe</label>
                <Input
                  id="inputMae"
                  invalid={!this.state.maeOk}
                  placeholder="Nome da Mãe completo"
                  innerRef={(ref) => (this.nome_mae = ref)}
                  onChange={this.handleIsValid}
                />
              </div>
              <div className="form-group ">
                <label htmlFor="cpf">CPF*</label>
                <MaskedInput
                  id="cpf"
                  mask={this.state.cpfRegex}
                  showMask="true"
                  invalid={!this.state.cpfOk}
                  onChange={(e) => {
                    this.handleIsValid(e);
                    this.setState({ cpfValue: e.target.value });
                  }}
                  render={(ref, props) => {
                    return <Input innerRef={(input) => (this.cpf = ref(input))} {...props} />;
                  }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="inputNasc">Data de nascimento*</label>
                <MaskedInput
                  mask={this.state.nascRegex}
                  showMask="true"
                  id="inputNasc"
                  onChange={(e) => {
                    this.handleIsValid(e);
                    this.setState({ datanascValue: e.target.value });
                  }}
                  invalid={!this.state.nascOk}
                  render={(ref, props) => {
                    return <Input innerRef={(input) => (this.datanasc = ref(input))} {...props} />;
                  }}
                />

                <div className="form-group">
                  <label htmlFor="sexo">Sexo*</label>
                  <Input
                    invalid={!this.state.sexoOk}
                    type="select"
                    id="sexo"
                    innerRef={(ref) => (this.sexo = ref)}
                    onChange={this.handleIsValid}
                  >
                    {Object.keys(sexos).map((key) => (
                      <option key={key} value={key}>
                        {sexos[key]}
                      </option>
                    ))}
                  </Input>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6">
              <div className="form-group ">
                <label htmlFor="inputContato1">Contato*</label>
                <MaskedInput
                  mask={this.state.contatoRegex}
                  showMask={true}
                  placeholder="Você será alertado por aqui"
                  id="inputContato1"
                  onChange={(e) => {
                    this.handleIsValid(e);
                    this.setState({ telefoneValue: e.target.value });
                  }}
                  invalid={!this.state.contatoOk}
                  render={(ref, props) => {
                    return <Input innerRef={(input) => (this.telefone = ref(input))} {...props} />;
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputEmail">Email*</label>
                <Input
                  invalid={!this.state.emailOk}
                  type="email"
                  className="form-control "
                  id="inputEmail"
                  placeholder="Email"
                  innerRef={(ref) => (this.email = ref)}
                  onChange={this.handleIsValid}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputPassword">Senha*</label>
                <Input
                  invalid={!this.state.senha1Ok}
                  type="password"
                  className="form-control"
                  id="inputPassword"
                  placeholder="Digite uma senha com no mínimo 06 caracteres"
                  innerRef={(ref) => (this.passwd = ref)}
                  onChange={this.handleIsValid}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputPassword2">Confirme sua senha*</label>
                <Input
                  invalid={!this.state.senha2Ok}
                  type="password"
                  className="form-control"
                  id="inputPassword2"
                  placeholder="Repita a senha"
                  innerRef={(ref) => (this.passwd2 = ref)}
                  onChange={this.handleIsValid}
                />
              </div>
              <div className="form-group">
                <div className="form-check"></div>
              </div>
            </div>
            <div className="col-12">
              <button type="submit" className="btn btn-primary mr-2" onClick={this.handleCadastro}>
                Cadastrar
              </button>
              <button type="submit" className="btn btn-danger" onClick={this.handleHome}>
                Cancelar
              </button>
            </div>
            <br />
            &nbsp;
          </div>

          <ModalAttention
            title="Atenção"
            show={this.state.modal}
            toggle={this.state.homeRedirect ? this.handleHome : this.onModal}
            ok={this.state.homeRedirect ? this.handleHome : this.onModal}
            className="text-dark"
          >
            {this.state.progressOk ? <Loading /> : null}
            {this.state.modalEmailEnv ? (
              <div>
                <p className="text-dark">
                  Enviamos uma mensagem de confirmação de cadastro para o seu email. O cadastro será
                  concluído após a confirmação de leitura dessa mensagem.
                </p>
                <p className="text-dark">
                  Obs: Se não recebeu a mensagem de confirmação, verifique a caixa de Spam/Lixeira do seu email. 
                </p>
              </div>
            ) : null}
            {this.state.aguarde ? <Loading /> : null}
            {this.state.modalCpf ? <p className="text-dark">Este Cpf já Existe</p> : null}
            {this.state.modalEmail ? <p className="text-dark">Este E-mail já existe</p> : null}
            {this.state.modalErrors ? (
              <p className="text-dark">Campos preenchidos incorretamente e/ou CPF inválido</p>
            ) : null}
          </ModalAttention>
        </form>
      </div>
    );
  }
}
export default Formulario;



// WEBPACK FOOTER //
// ./src/pages/Formulario.js